import { Action } from '@ngrx/store';
import {
  CorporateDashboardQuery,
  CorporateAppointmentsResponse,
  DashboardCountsData
} from '../../shared/services/corporate-appointment-dashboard.service';

export enum CorporateDashboardActionTypes {
  SET_QUERY = '[Corporate dashboard page] Set query',
  LOAD_APPOINTMENTS = '[Corporate dashboard page] Load appointments',
  LOAD_APPOINTMENTS_SUCCESS = '[Corporate dashboard API] Load appointments success',
  LOAD_APPOINTMENTS_FAILURE = '[Corporate dashboard API] Load appointments failure',
  LOAD_DASHBOARD_COUNTS = '[Corporate dashboard page] Load dashboard counts',
  LOAD_DASHBOARD_COUNTS_SUCCESS = '[Corporate dashboard API] Load dashboard counts success',
  LOAD_DASHBOARD_COUNTS_FAILURE = '[Corporate dashboard API] Load dashboard counts failure'
}

export class SetCorporateDashboardQuery implements Action {
  readonly type: string = CorporateDashboardActionTypes.SET_QUERY;

  constructor(public payload: { query: CorporateDashboardQuery }) {
  }
}

export class LoadCorporateDashboardAppointments implements Action {
  readonly type: string = CorporateDashboardActionTypes.LOAD_APPOINTMENTS;

  constructor(public payload: { query: CorporateDashboardQuery }) {
  }
}

export class LoadCorporateDashboardAppointmentsSuccess implements Action {
  readonly type: string = CorporateDashboardActionTypes.LOAD_APPOINTMENTS_SUCCESS;

  constructor(public payload: { appointments: CorporateAppointmentsResponse }) {
  }
}

export class LoadCorporateDashboardAppointmentsFailure implements Action {
  readonly type: string = CorporateDashboardActionTypes.LOAD_APPOINTMENTS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export class LoadDashboardCounts implements Action {
  readonly type: string = CorporateDashboardActionTypes.LOAD_DASHBOARD_COUNTS;
}

export class LoadDashboardCountsSuccess implements Action {
  readonly type: string = CorporateDashboardActionTypes.LOAD_DASHBOARD_COUNTS_SUCCESS;

  constructor(public payload: { counts: DashboardCountsData }) {
  }
}

export class LoadDashboardCountsFailure implements Action {
  readonly type: string = CorporateDashboardActionTypes.LOAD_DASHBOARD_COUNTS_FAILURE;

  constructor(public payload: { error: string }) {
  }
}

export type CorporateDashboardActions =
  | SetCorporateDashboardQuery
  | LoadCorporateDashboardAppointments
  | LoadCorporateDashboardAppointmentsSuccess
  | LoadCorporateDashboardAppointmentsFailure
  | LoadDashboardCounts
  | LoadDashboardCountsSuccess
  | LoadDashboardCountsFailure;
